export default __webpack_public_path__ + "static/media/Schaf.eff100be.webp";